let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("jkFsZ")).then(() => parcelRequire('imW3j'));